/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowADownRightIcon64Regular = forwardRef('ArrowADownRightIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "m48.44 50.561-36-36a1.5 1.5 0 0 1 2.12-2.122L50.562 48.44A4.481 4.481 0 0 0 51 46.5v-26a1.5 1.5 0 1 1 3 0v26a7.5 7.5 0 0 1-7.5 7.5h-26a1.5 1.5 0 0 1 0-3h26c.695 0 1.353-.157 1.94-.439Z" })));
});
